import { useMemo } from 'react';
import { UIMatch, useLocation, useMatches } from 'react-router-dom';
import { RouteHandleBreadcrumb } from '@/types/route-handle-breadcrumb';
import { useBreadcrumbsContext } from './use-breadcrumbs-context';
import { Breadcrumb } from '../types/breadcrumb';
import { filterPreRootCrumbs } from '../utils/filter-pre-root-crumbs';
import { matchHasCrumb } from '../utils/match-has-crumb';
import { matchToCrumb } from '../utils/match-to-crumb';

export const useBreadcrumbs = () => {
  const matches = useMatches() as UIMatch<
    unknown,
    undefined | { crumb: RouteHandleBreadcrumb }
  >[];
  const { pathname } = useLocation();
  const { titles } = useBreadcrumbsContext();

  return useMemo(() => {
    const crumbs = matches
      .filter(matchHasCrumb)
      .map(matchToCrumb({ pathname, titles }));

    if (crumbs.includes('hide')) {
      return [];
    }

    return filterPreRootCrumbs(crumbs as Breadcrumb[]).filter(
      (crumb) => crumb.display,
    );
  }, [matches, titles, pathname]);
};
